import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItDidntWork data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <FinalOffer data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <WhoThisIsFor data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <SocialProof data-id="element-10" />
      <FAQ data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}